import React, { createContext, FC, PropsWithChildren, useContext } from 'react';
import { ToastProvider } from '@greatmindsorg/gmui-lib/dist/components/Toast/Toast.component';
export const ToastContext = createContext(null);
const CustomToastProvider: FC<PropsWithChildren> = ({
  children
}) => <ToastProvider>
    {state => <ToastContext.Provider value={state}>{children}</ToastContext.Provider>}
  </ToastProvider>;
const useCustomToast = () => useContext(ToastContext);
export { CustomToastProvider, useCustomToast };